import { IconProps } from "@/src/sb/business-layer/types"
import React from "react"

const ArrowListIcon = ({ width, height, size }: IconProps) => (
  <svg
    width={width ?? size ?? 12}
    height={height ?? size ?? 12}
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.75 2.25L6.225 2.775L9.0375 5.625H1.125V6.375H9.0375L6.225 9.225L6.75 9.75L10.5 6L6.75 2.25Z"
      fill="currentColor"
    />
  </svg>
)

export default ArrowListIcon
